class DepartmentGoogleMap {

	constructor() {
		let $ = jQuery;
		let self = this;
		setTimeout(function(){
			$( '.department-map-wrapper' ).each(function() {
				return self.initMap( $(this) );
			});	
		},1200);
	}

	/**
	 * initMap
	 *
	 * Renders a Google Map onto the selected jQuery element
	 *
	 * @param   jQuery $el The jQuery element.
	 * @return  object The map instance.
	 */
	initMap( $el ) {
		let $ = jQuery;
		// Find marker elements within map.
		let $markers = $el.find('.marker');

		// Removes points of intrest from the map
		let removeDefaultLabels = [
			{
				featureType: "poi",
				elementType: "labels",
				stylers: [
					  { visibility: "off" }
				]
			}
		];

		// Create generic map.
		let mapArgs = {
			zoom        : $el.data('zoom') || 16,
			mapTypeId   : google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: removeDefaultLabels,
		};

		let map = new google.maps.Map( $el[0], mapArgs );




		// Add markers.
		map.markers = [];
		let that = this;
		$markers.each(function(){
			that.initMarker( $(this), map );
		});

		// Center map based on markers.
		this.centerMap( map );

		// Return map instance.
		return map;
	}

	/**
	 * initMarker
	 *
	 * Creates a marker for the given jQuery element and map.
	 *
	 * @param   jQuery $el The jQuery element.
	 * @param   object The map instance.
	 * @return  object The marker instance.
	 */
	initMarker( $marker, map ) {
		let $ = jQuery;
		// Get position from marker.
		let lat = $marker.data('lat');
		let lng = $marker.data('lng');
		let latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		// Create marker instance.
		let icon = $marker.data('icon');
		let marker = new google.maps.Marker({
			position : latLng,
			map: map,
			icon: icon,
		});

		// Append to reference for later use.
		map.markers.push( marker );

		// If marker contains HTML, add it to an infoWindow.
		if( $marker.html() ) {

			// Create info window.
			let infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	}

	/**
	 * centerMap
	 *
	 * Centers the map showing all markers in view.
	 *
	 * @param   object The map instance.
	 * @return  void
	 */
	centerMap( map ) {
		let $ = jQuery;
		// Create map boundaries from all map markers.
		let bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );

		// Case: Multiple markers.
		} else{
			map.fitBounds( bounds );
		}
	}
}

export default DepartmentGoogleMap;
